import axiosUrl from './axios.service';
import axios from 'axios';
import store from '../store/index';
import authHeader from '../helpers/auth-header';
import AuthService from '../services/auth.service';
import router from '../router';

const API_URL = axiosUrl.getAxiosUrl();

class OrganisationsService {
  getAllOrganisations() {
    return axios
      .get(API_URL + '/organisations/getAllOrganisations', {
        headers: authHeader(),
      })
      .then((response) => {
        store.commit('organisations/updateOrganisations', response.data);
        /*  store.commit('grantItems/disableSearchPageLoading'); */
      })
      .catch((error) => {
        if (error.response.status === 401 || error.response.status === 403) {
          // auto logout if 401 or 403 response returned from api
          AuthService.logout();
          router.go();
        }
      });
    /*      .catch((error) => {
        if (error)
          store.commit('tree/updateModalError', error.response.data),
            store.commit('tree/enableModalError');
      }); */
  }
  
  getAllOrganisationsWithBasicInfo() {
    return axios
      .get(API_URL + '/organisations/getAllOrganisationsWithBasicInfo', {
        headers: authHeader(),
      })
      .then((response) => {
        store.commit('organisations/updateOrganisationsWithBasicInfo', response.data);
      })
      .catch((error) => {
        if (error.response.status === 401 || error.response.status === 403) {
          // auto logout if 401 or 403 response returned from api
          AuthService.logout();
          router.go();
        }
      });
  }
}

export default new OrganisationsService();
